import Router from 'vue-router';
import MasterPage from './components/layouts/master-page';
import GuestPage from './components/layouts/guest-page';
import HomePage from './components/pages/home';
import ProductsPage from './components/pages/products';
import BasketPage from './components/pages/basket';
import PaymentPage from './components/pages/pg/payment';
import SuccessPage from './components/pages/pg/success';
import ReceiptPage from './components/pages/receipt';
import TokushoPage from './components/pages/tokusho';
import AccountPage from './components/pages/account';
import SignInPage from './components/pages/auth/signin';
import SignInAsPage from './components/pages/auth/signin-as';
import SignOutPage from './components/pages/auth/signout';
import SwitchBackPage from './components/pages/auth/switchback';
import ControlSettingsPage from './components/pages/auth/controls';
import WorkerManagementPage from './components/pages/admin/worker/worker-management';
import InvestigationPage from './components/pages/admin/subscription/investigation';
import StripeConversionPage from './components/pages/transition/stripe-conversion';
import OfferPage from './components/pages/offer';
import SurveyPage from './components/pages/survey';
import AppSession from './js/session/AppSession';
import PageNotFound from './components/pages/notfound';
import autoLoginGuard from './js/guards/autoLoginGuard';

let routes = [
    {
        // Pages under this parent path are secure pages, set neutralPage to false if need to show both secured/guest
        path: '/',
        component: MasterPage,
        meta: { requiresAuth: true, neutralPage: true },
        children: [
            {
                path: '/',
                component: HomePage,
                meta: { requiresAuth: true, neutralPage: true }
            },
            {
                path: '/products',
                component: ProductsPage,
                meta: { requiresAuth: true, neutralPage: true, title: '商品一覧 - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/basket',
                component: BasketPage,
                meta: { requiresAuth: true, neutralPage: false, title: '申し込み内容確認 - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/payment',
                component: PaymentPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'お支払い方法 - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/payment-success',
                component: SuccessPage,
                meta: { requiresAuth: true, neutralPage: false, title: '支払いの成功 - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/receipt',
                component: ReceiptPage,
                meta: { requiresAuth: true, neutralPage: false, title: ''}
            },
            {
                path: '/account',
                component: AccountPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'アカウントページ - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/signout',
                component: SignOutPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'ログアウト - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/impersonate',
                component: SignInAsPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'Session spoofer' }
            },
            {
                path: '/switchback',
                component: SwitchBackPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'Switching Back' }
            },
            {
                path: '/controls',
                component: ControlSettingsPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'Control Settings Page' }
            },
            {
                path: '/worker-management',
                component: WorkerManagementPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'Worker Management Page' }
            },
            {
                path: '/problematic-subscriptions',
                component: InvestigationPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'Problematic Subscription Investigation Page' }
            },
            {
                path: '/transition',
                component: StripeConversionPage,
                meta: { requiresAuth: true, neutralPage: false, title: '新規決済事業者への移行 - 英辞郎 on the WEB Pro ショップ' }
            },
            {
                path: '/offer',
                component: OfferPage,
                meta: { requiresAuth: true, neutralPage: false, title: 'ご利用の御礼' }
            },
            {
                path: '/survey',
                component: SurveyPage,
                meta: { requiresAuth: true, neutralPage: true, title: 'ご利用停止のアンケートにご協力ください' }
            },
        ]
    },
    {
        // Pages under this parent path are guest pages, set strictlyEnforced to false if need to show both secured/guest
        path: '/',
        component: GuestPage,
        meta: { requiresAuth: false, neutralPage: true },
        children: [
            {
                path: '/tokusho',
                component: TokushoPage,
                meta: { requiresAuth: false, neutralPage: true, title: '特定商取引に関する法律に基づく表示 - 英辞郎 on the WEB Pro ショップ'}
            },
            {
                path: '/signin',
                component: SignInPage,
                meta: { requiresAuth: false, neutralPage: false,  title: 'ログイン - 英辞郎 on the WEB Pro ショップ'}
            },
            {
                path: '*',
                component: PageNotFound,
                meta: { requiresAuth: false, neutralPage: true }
            },
        ]
    }
];

const router = new Router({
    routes,
    linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

// Enforcing rules via meta
let appSession = new AppSession();
router.beforeEach(async (to, from, next) => {
    // Attempt Cognito auto-login once per load
    await autoLoginGuard();

    // This page requires authentication
    if (to.matched.some(m => m.meta.requiresAuth && !m.meta.neutralPage)) {
        return appSession.isAuthenticated().then(authenticated => {
            if (!authenticated) {
                return next({ path: '/signin' });
            }
            return next();
        });
    }

    // This page is for unauthenticated user
    if (to.matched.some(m => !m.meta.requiresAuth && !m.meta.neutralPage)) {
        return appSession.isAuthenticated().then(authenticated => {
            if (authenticated) {
                return next({ path: '/' });
            }
            return next();
        });
    }

    return next();
});

export default router;
